import { Box, Text } from "@chakra-ui/react";
import React from "react";
import "../Styles/plant.css";
import ByCategory from "./Shop/ByCategory";
import ByTrending from "./Shop/ByTrending";
import Indoor from "./Shop/Indoor";
import ByArtFrames from "./Shop/ByArtFrames";
import WishfyArtFrames from "./Shop/WishfyArtFrames";
import TopSlider from "../Components/Home/TopSlider";
import ByHomeDecor from "./Shop/ByHomeDecor";

const PlantsLanding = () => {
  return (
    <>
      <TopSlider />
      {/* Indoor  */}
      <Text
        fontStyle={"Oswald"}
        fontWeight={"bold"}
        fontSize={{ md: 25, base: 20 }}
        color={"#3C375F"}
        letterSpacing={0}
        opacity={1}
        my={5}
        px={10}
        textAlign={"left"}
        // display={{ md: "block", base: "none" }}
      >
        Shop By Category
      </Text>
      <Box
        textAlign={"left"}
        px={10}
        py={5}
        className="indoor_section"
        // display={{ md: "block", base: "none" }}
      >
        <Indoor />
      </Box>
      {/* trending  */}
      <Box w={"100%"} mt={2} textAlign={"left"} px={10}>
        <ByTrending />
      </Box>

      {/* By Art Frames  */}
      <Box w={"100%"} mt={5} textAlign={"left"} px={10}>
        <ByArtFrames />
      </Box>

      <Box w={"100%"} mt={5} textAlign={"left"} px={10}>
        <ByHomeDecor />
      </Box>

      {/* Wishfy Art Frames  */}
      <Box w={"100%"} mt={5} textAlign={"left"} px={10} mb={10}>
        <WishfyArtFrames />
      </Box>
    </>
  );
};

export default PlantsLanding;
